import type { FC } from "react";
import { OverlayTrigger } from "react-bootstrap";

import { QuestionIcon } from "../icons/QuestionIcon";
import { renderTooltip } from "../StyledTooltip/StyledTooltip";

const ModelsInfoTableTitle: FC = () => {
  return (
    <tr>
      <td>Model name</td>
      <td>
        Tokens
        <div>
          <span>
            Paid
            <OverlayTrigger
              placement="bottom"
              overlay={renderTooltip(
                "Amount of paid tokens consumed per model for the current billing period. Paid tokens are generated by the LLM and not coming from cache.",
              )}
            >
              <span className="ms-1">
                <QuestionIcon size={12} />
              </span>
            </OverlayTrigger>
          </span>
          <span>
            Free
            <OverlayTrigger
              placement="bottom"
              overlay={renderTooltip(
                "Amount of free tokens consumed per model for the current billing period. Free tokens are generated from the cache and are free of charge",
              )}
            >
              <span className="ms-1">
                <QuestionIcon size={12} />
              </span>
            </OverlayTrigger>
          </span>
        </div>
      </td>
      <td>
        Cost savings
        <OverlayTrigger
          placement="bottom"
          overlay={renderTooltip(
            "Amount of cost savings per model for the current billing period based on token discounts and caching.",
          )}
        >
          <span className="ms-1">
            <QuestionIcon size={12} />
          </span>
        </OverlayTrigger>
      </td>
      <td>Total cost</td>
    </tr>
  );
};

export { ModelsInfoTableTitle };
